import { Component, Input } from '@angular/core';
import { LangService } from '../../service/lang.service';
import { translations } from '../../service/trans';

@Component({
  selector: 'app-subfooter',
  templateUrl: './subfooter.component.html',
  styleUrl: './subfooter.component.css',
})
export class SubfooterComponent {
  // @Input() t: any;
  lang = 'en';
  t: any;

  constructor(private langService: LangService) {}

  ngOnInit() {
    this.langService.lang$.subscribe((lang) => {
      this.lang = lang;
      this.t = translations[lang];
    });
  }
}
